import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Filters } from "../../../../assets/filters.svg";
import style from "./style.module.scss";

const FiltersPannelButton = () => {
  const [openFiltersPannel, setOpenFiltersPannel] = useState(false);
  // React i18next
  const { t } = useTranslation();

  // Open or close the filters pannel according to "openFiltersPannel"
  useEffect(() => {
    let leftCol = document.querySelector(".archive-product-left-col");
    let filters = document.querySelector(".archive-product-filters");

    if (leftCol && filters) {
      if (openFiltersPannel) {
        document.body.style.overflow = "hidden";
        leftCol.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
        leftCol.style.zIndex = "50";
        filters.style.left = "0px";
      } else {
        document.body.style.overflow = "visible";
        leftCol.style.backgroundColor = "rgba(0, 0, 0, 0)";
        leftCol.style.zIndex = "-1";
        filters.style.left = "-100%";
      }
    }
  }, [openFiltersPannel]);

  // Listen to the event "onSbmArchiveProductCloseFiltersPannel".
  useEffect(() => {
    const callback = (e) => setOpenFiltersPannel(e.detail);
    document.addEventListener(
      "onSbmArchiveProductCloseFiltersPannel",
      callback
    );
    return () => {
      document.removeEventListener(
        "onSbmArchiveProductCloseFiltersPannel",
        callback
      );
    };
  }, []);

  return (
    <div
      className={style.filterButton}
      onClick={() => setOpenFiltersPannel(!openFiltersPannel)}
    >
      <Filters />
      <span>{t("Filters")}</span>
    </div>
  );
};

export default FiltersPannelButton;
